import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField, Tabs, Tab, withStyles, WithStyles} from '@material-ui/core';
import Button from "@components/common/button/Button";
import * as React from 'react';
import CloseIcon from "@material-ui/icons/Close";
import { IFamilyMember, IFamilyMemberFileIdUpdate } from '@app-types/websocket/family.types';
import ImgAvatar from '@components/common/avatar/ImgAvatar';
import { FamilyMemberType, FamilyMemberSex } from '@services/family/family.constants';
import TranslateNew from '@translate/TranslateNew';
import CreateAvatar from './createAvatar';
import { DialogTop } from '@components/economy/DialogComponens';
import { standardFamilyColors } from '@services/family/family.utils';
import { FamilyStyle } from './Family.style';
import { styleColors } from 'src/main.style';

const defaultAvatarImg = "profile.png";

const tn :TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof FamilyStyle>{
  isOpen: boolean;
  familyMember: IFamilyMember;
  onClose: () => void;
  onSubmit: (values:IFamilyMember) => void;
  onSaveFile: (fileId:IFamilyMemberFileIdUpdate) => void;
}

interface IState {
  avatar:number;
  firstName:string;
  lastName:string;
  sex:string;
  scale:number;
  useCustomAvatar:boolean;
  editCustomAvatar:boolean;
}

class UpdateFamilyMemberDialog extends React.Component<IProps, IState> {
  

  constructor(props: IProps) {
    super(props);

    let currentSex:string = "OTHER";
    if ( props.familyMember.sex === "MAN") {
      currentSex = "MAN";
    } else if (props.familyMember.sex === "WOMAN") {
      currentSex = "WOMAN";
    }

    this.state = {
      avatar:props.familyMember.avatar,
      firstName: props.familyMember.firstName,
      lastName: props.familyMember.lastName,
      sex: currentSex,
      scale:100,
      useCustomAvatar:props.familyMember.imageAvatar?true:false,
      editCustomAvatar:false,
    };
  }

  public render() {
    const { familyMember } = this.props;



    if (!familyMember)
    {
      return null;
    }

    const imgUrl = this.props.familyMember.avatarURL
      ? this.props.familyMember.avatarURL
      : defaultAvatarImg;

    
    return (<>
      <Dialog
      open={this.props.isOpen}
      onClose={this.props.onClose}
      >
        <DialogTitle>
          {tn.lang.settingsUpdateFamilyMemberName(familyMember.firstName)}
        </DialogTitle>
        <DialogContent style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
          <Tabs value={this.state.useCustomAvatar?0:1} onChange={(event, value) => this.setState({useCustomAvatar:(value===0)})} >
            <Tab label={tn.lang.avatarPhoto}/>
            <Tab label={tn.lang.avatarDrawn} />
          </Tabs>
          {this.state.useCustomAvatar
          ? <div 
              style={{
                background: ("center / cover no-repeat url("+imgUrl+"), "+familyMember.color),
                minWidth: '200px',
                minHeight: '200px',
                alignSelf: 'center',
                borderRadius: '300px'}} 
              onClick={() => this.setState({editCustomAvatar:true})} />
            : <div style={{marginTop: '8px'}}>
              {this.generateAvatarButtons(
                this.state.sex,
                familyMember.role,
                this.state.avatar,
                familyMember.color
              )}
            </div>
          }
          <TextField
            id="firstName"
            name="firstName"
            onChange={(e) => this.setState({firstName:e.target.value})}
            value={this.state.firstName}
            inputProps={{maxLength:15}}
            variant="outlined"
            label={tn.lang.name}
          />
          <TextField
            id="lastName"
            name="lastName"
            onChange={(e) => this.setState({lastName:e.target.value})}
            value={this.state.lastName}
            inputProps={{maxLength:25}}
            variant="outlined"
            label={tn.lang.sirname}
          />
          <div style={{position: 'relative', display: 'flex', flexDirection: 'column'}}>
            <select
                value = {this.state.sex}
                onChange = {(e) => this.setState({sex:e.target.value})}
                className = {this.props.classes.dropBox}
            >
              <option key={"WOMAN"} value={"WOMAN"}>
                {familyMember.role===FamilyMemberType.CHILD
                  ?tn.lang.girl
                  :tn.lang.woman
                }
              </option>
              <option key={"MAN"} value={"MAN"}>
              {familyMember.role===FamilyMemberType.CHILD
                ?tn.lang.boy
                :tn.lang.man
              }
              </option>
              <option key={"OTHER"} value={"OTHER"}>
                {tn.lang.other}
              </option>
            </select>
            <div style={{    position: 'absolute',top: '-6px',color: styleColors.greyMedium3,backgroundColor: styleColors.white,left: '8px',
              fontSize: '12px',padding: '0px 4px',}}>{tn.lang.sex}</div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose}>{tn.lang.cancel}</Button>
          <Button 
            disabled={(this.state.firstName.trim().length < 1)}
            onClick={() => this.handleSubmit()} variant="contained" color ="primary">
              {tn.lang.save}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={this.state.editCustomAvatar}
        onClose={() => this.setState({editCustomAvatar:false})}
        >
        <DialogTop>
          <DialogTitle>{tn.lang.settingsAdjustImage}</DialogTitle>
          <IconButton onClick={() => {this.setState({editCustomAvatar:false});}}>
            <CloseIcon />
          </IconButton>
        </DialogTop>
        <DialogContent style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
          <CreateAvatar 
            close={() => this.setState({editCustomAvatar:false})}
            saveFileIdToAccount={(fileId:number) => {
              this.props.onSaveFile({familyMemberId: this.props.familyMember.id, fileId});
              this.setState({editCustomAvatar:false});
            }}
            startImageURL={defaultAvatarImg} />
        </DialogContent>
      </Dialog>
      </>
    );
  }

  private generateAvatarButtons(sex:string, role:string, currentAvatar:number, color:string) {
    let base:number = 0;
    let amount:number = 10;

    if (role === FamilyMemberType.CHILD)
    {
      if (sex === FamilyMemberSex.WOMAN)
      {
        base=300;
        amount=43;
      } else if  (sex === FamilyMemberSex.MAN)
      {
        base=400;
        amount=42;
      }
    } else {
      if (sex === FamilyMemberSex.WOMAN)
      {
        base=100;
        amount=69;
      } else if  (sex === FamilyMemberSex.MAN)
      {
        base=200;
        amount=71; 
      }
    }

    const buttons:any[] = [];
    for(let i:number = 0; i < amount; i+=1)
    {
      if (i===1) {continue;}
      const avatarNumber:number = i+base;
      const isCurrent:boolean = (avatarNumber === currentAvatar);
      buttons.push(
        <IconButton 
          style={isCurrent?{borderWidth: '2px', borderStyle: 'dashed', padding: '4px'}:{margin: '2px', padding: '4px'}}
          onClick={() => this.setAvatar(avatarNumber)} key={avatarNumber}>
          <ImgAvatar imgName={avatarNumber}  color={color} imgUrl={undefined}/>
        </IconButton>
      );
    }
    return buttons;
  }

  private setAvatar(avatar:number) {
    this.setState({avatar});
  }

  private handleSubmit = () => {
    const update:IFamilyMember = {
      ...this.props.familyMember,
      avatar:this.state.avatar,
      sex:this.state.sex,
      firstName:this.state.firstName,
      lastName:this.state.lastName,
      imageAvatar:this.state.useCustomAvatar,
    };
    this.props.onSubmit(update);
  }
}

export default withStyles(FamilyStyle)(UpdateFamilyMemberDialog);



// WEBPACK FOOTER //
// ./src/components/extended-family/update-family-member/UpdateFamilyMemberDialog.tsx